<template>
	<div class="practice-error-container">
		<!-- Left Panel -->
		<div class="chat-history-panel">
			<h2 class="panel-title">对话历史</h2>

			<div v-if="chatHistoryData.length === 0" class="empty-state">
				暂无对话历史
			</div>

			<div class="chat-list">
				<div
					v-for="(obj, index) in chatHistoryData"
					:key="index"
					class="chat-card"
					:class="{'active': currentObj === obj}"
					@click="selectChat(obj)"
				>
					<div class="chat-card-header">
						<span class="chat-type" :class="'type-' + obj.type">{{ showType(obj.type) }}</span>
						<span class="chat-time">{{ obj.createTime }}</span>
					</div>

					<div class="chat-content">
						{{ obj.chatContent }}
						<button
							v-if="obj.chatVoiceUrl"
							@click.stop="toggleAudio(obj, index)"
							class="audio-btn"
						>
							<i class="audio-icon" :class="audioPlaying[index] ? 'playing' : ''"></i>
							{{ audioPlaying[index] ? '暂停' : '播放' }}
						</button>
						<audio :id="`audio-${index}`" :src="obj.chatVoiceUrl" style="display:none"></audio>
					</div>

					<div class="chat-media">
						<div v-if="obj.captureImgUrl" class="image-item">
							<img
								:src="obj.captureImgUrl"
								class="thumbnail-img"
								@click.stop="showLargeImage(obj.captureImgUrl)"
								alt="Captured image"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Right Panel -->
		<div v-if="currentObj.type == 1" class="detail-panel simple-panel">
			<div class="qa-section">
				<div class="detail-card">
					<div class="card-header">
						<h3 class="detail-title">对话详情</h3>
						<span class="chat-type type-1">{{ showType(currentObj.type) }}</span>
					</div>

					<div class="card-content">
						<div class="conversation-simple">
							<div class="conversation-item">
								<div class="item-label">提问内容</div>
								<div class="item-content">{{ currentObj.chatContent || '暂无提问内容' }}</div>
								<div class="item-time">{{ currentObj.createTime }}</div>
							</div>

							<div class="conversation-divider"></div>

							<div class="conversation-item">
								<div class="item-label">回答内容</div>
								<div class="item-content" v-html="currentObj.answerContent || '暂无答案内容'"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="currentObj.type == 2" class="detail-panel">
			<div class="qa-section">
				<div class="detail-card">
					<div class="card-header">
						<h3 class="detail-title">问题详情</h3>
						<span class="chat-type" :class="currentObj.type ? 'type-' + currentObj.type : ''">
							{{ currentObj.type ? showType(currentObj.type) : '' }}
						</span>
					</div>

					<div class="card-content">
						<div class="question-text">
							<div class="content-label">提问内容：</div>
							<div class="content-value">{{ currentObj.chatContent || '暂无提问内容' }}</div>
						</div>

						<div class="question-image">
							<div class="content-label">问题图片：</div>
							<div class="image-container question-img-container">
								<img
									v-if="currentObj.questionImgUrl"
									:src="currentObj.questionImgUrl"
									alt="Question image"
									class="question-img"
									@click="showLargeImage(currentObj.questionImgUrl)"
								/>
								<div v-else class="no-content">暂无问题图片</div>
							</div>
						</div>
					</div>
				</div>

				<div class="detail-card">
					<div class="card-header">
						<h3 class="detail-title">答案内容</h3>
					</div>

					<div class="card-content">
						<div class="answer-content" v-html="currentObj.pageAnswerContent || '暂无答案内容'"></div>
					</div>
				</div>
			</div>

			<div class="image-section">
				<div class="detail-card">
					<div class="card-header">
						<h3 class="detail-title">图片详情</h3>
					</div>

					<div class="card-content">
						<div class="image-grid">
							<div class="image-item">
								<div class="image-container">
									<img
										v-if="currentObj.orgImgUrl"
										:src="currentObj.orgImgUrl"
										class="detail-img"
										@click="showLargeImage(currentObj.orgImgUrl)"
										alt="Original image"
									/>
									<div v-else class="no-image">无图片</div>
								</div>
								<div class="image-label">原始图片</div>
							</div>

							<div class="image-item">
								<div class="image-container">
									<img
										v-if="currentObj.dealImgUrl"
										:src="currentObj.dealImgUrl"
										class="detail-img"
										@click="showLargeImage(currentObj.dealImgUrl)"
										alt="Processed image"
									/>
									<div v-else class="no-image">无图片</div>
								</div>
								<div class="image-label">截取图片</div>
							</div>

							<div class="coordinate-container">
								<div class="coordinate-card">
									<div class="coordinate-icon"></div>
									<div class="coordinate-content">
										<div class="position-label">手指坐标</div>
										<div class="position-value">{{ currentObj.fingerPos || '暂无数据' }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="currentObj.type == 3" class="detail-panel">
			<div class="qa-section">
				<div class="detail-card">
					<div class="card-header">
						<h3 class="detail-title">错题列表</h3>
						<span class="chat-type type-3">{{ showType(currentObj.type) }}</span>
					</div>

					<div class="card-content">
						<div v-if="currentObj.requestErrorRecordDTO && currentObj.requestErrorRecordDTO.questionList"
							class="question-list">
							<div v-for="(question, index) in currentObj.requestErrorRecordDTO.questionList"
								:key="index"
								class="question-item">
								<div class="question-number">题目 {{ index + 1 }}</div>
								<!-- <div class="question-content">{{ question }}</div> -->
								 <div style="display: flex;">
									<div style="width: 40%;" v-if="question.imgUrl" class="question-image-container">
									<img
										:src="question.imgUrl"
										class="question-thumbnail"
										@click="showLargeImage(question.imgUrl)"
										alt="Question image"
									/>
								</div>
								<div style="    border-right: 1px solid rgb(121 114 114);width: 1px;height: 25px;margin: 20px;"></div>
								<div  style="padding-left: 20px;width: 60%;margin-top: 20px;;">{{question.text}}</div>
								 </div>

							</div>
						</div>
						<div v-else class="no-content">暂无错题数据</div>
					</div>
				</div>

				<div class="detail-card">
					<div class="card-header">
						<h3 class="detail-title">拍摄图片</h3>
					</div>

					<div class="card-content">
						<div class="image-grid">
							<div class="image-item">
								<div class="image-container">
									<img
										v-if="currentObj.requestErrorRecordDTO && currentObj.requestErrorRecordDTO.orgImgUrl"
										:src="currentObj.requestErrorRecordDTO.orgImgUrl"
										class="detail-img"
										@click="showLargeImage(currentObj.requestErrorRecordDTO.orgImgUrl)"
										alt="Original image"
									/>
									<div v-else class="no-image">无原始图片</div>
								</div>
								<div class="image-label">原始图片</div>
							</div>

							<div class="image-item">
								<div class="image-container">
									<img
										v-if="currentObj.requestErrorRecordDTO && currentObj.requestErrorRecordDTO.dealImgUrl"
										:src="currentObj.requestErrorRecordDTO.dealImgUrl"
										class="detail-img"
										@click="showLargeImage(currentObj.requestErrorRecordDTO.dealImgUrl)"
										alt="Processed image"
									/>
									<div v-else class="no-image">无处理图片</div>
								</div>
								<div class="image-label">处理图片</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Image Modal -->
		<div v-if="showImageModal" class="image-modal" @click="closeImageModal">
			<div class="modal-content">
				<button class="close-btn" @click.stop="closeImageModal">×</button>
				<img :src="currentLargeImage" class="large-image" alt="Enlarged image" />
			</div>
		</div>
	</div>
</template>

<script>
	import {axios} from "../../config/axios";
	export default {
		name: 'PracticeError',
		data() {
			return {
				questionImgUrl:'',
				chatHistoryData:[],
				audioPlaying: {},
				currentAudio: null,
				showImageModal: false,
				currentLargeImage: '',
				currentObj:{},
			}
		},
		created() {
			this.getData();
		},
		methods: {
			selectChat(obj) {
				this.currentObj = obj;
			},

			getData () {
				axios.get('/requestAnswerRecord',{
					params: {},
				}).then(response => {
					console.info("res:{}",response);
					let res = response.data;
					if (res.code != 200){
						console.error(res)
					}
					this.chatHistoryData = res.data.list;
					if (this.chatHistoryData && this.chatHistoryData.length > 0) {
						this.currentObj = this.chatHistoryData[0];
					}
					console.info("----",this.currentObj )
				}).catch(err => {
					console.log(err);
				});
			},
			showType(type){
				if (type == 1){
					return "对话";
				} else if (type == 2){
					return "指令";
				} else if (type == 3) {
					return "错题";
				}
				return "_"
			},
			toggleAudio(obj, index) {
				const audio = document.getElementById(`audio-${index}`);

				// If there's another audio playing, stop it first
				if (this.currentAudio && this.currentAudio !== audio) {
					this.currentAudio.pause();
					this.currentAudio.currentTime = 0;
					const prevIndex = Object.keys(this.audioPlaying).find(key => this.audioPlaying[key] === true);
					if (prevIndex) this.$set(this.audioPlaying, prevIndex, false);
				}

				if (!this.audioPlaying[index]) {
					// Play this audio
					audio.play().then(() => {
						this.$set(this.audioPlaying, index, true);
						this.currentAudio = audio;

						// When audio ends, reset state
						audio.onended = () => {
							this.$set(this.audioPlaying, index, false);
							this.currentAudio = null;
						};
					}).catch(e => {
						console.error('Error playing audio:', e);
					});
				} else {
					// Pause this audio
					audio.pause();
					audio.currentTime = 0;
					this.$set(this.audioPlaying, index, false);
					this.currentAudio = null;
				}
			},
			showLargeImage(imageUrl) {
				this.currentLargeImage = imageUrl;
				this.showImageModal = true;
			},

			closeImageModal() {
				this.showImageModal = false;
				this.currentLargeImage = '';
			}
		}
	}
</script>

<style scoped>
	/* Main Layout */
	.practice-error-container {
		display: flex;
		flex-direction: row;
		gap: 24px;
		height: 100vh;
		padding: 20px;
		background-color: #f5f7fa;
		color: #333;
		font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
		overflow: hidden;
	}

	/* Left Panel - Chat History */
	.chat-history-panel {
		flex: 0 0 340px;
		display: flex;
		flex-direction: column;
		background: white;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		overflow: hidden;
		max-height: 100%;
	}

	.panel-title {
		margin: 0;
		padding: 16px 20px;
		font-size: 18px;
		font-weight: 600;
		color: #2c3e50;
		border-bottom: 1px solid #eaedf2;
	}

	.status-badge {
		display: flex;
		align-items: center;
		margin: 16px 20px 0;
		padding: 6px 12px;
		border-radius: 16px;
		font-size: 14px;
		font-weight: 500;
	}

	.status-icon {
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
		margin-right: 8px;
	}

	.status-badge.connected {
		background-color: #e6f7e6;
		color: #2e7d32;
	}

	.status-badge.connected .status-icon {
		background-color: #4caf50;
	}

	.status-badge.disconnected, .status-badge.closed {
		background-color: #f5f5f5;
		color: #757575;
	}

	.status-badge.disconnected .status-icon, .status-badge.closed .status-icon {
		background-color: #9e9e9e;
	}

	.status-badge.connecting {
		background-color: #e3f2fd;
		color: #1976d2;
	}

	.status-badge.connecting .status-icon {
		background-color: #2196f3;
	}

	.status-badge.error {
		background-color: #feeceb;
		color: #d32f2f;
	}

	.status-badge.error .status-icon {
		background-color: #f44336;
	}

	.chat-list {
		flex: 1;
		overflow-y: auto;
		padding: 12px;
	}

	.empty-state {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 200px;
		color: #9e9e9e;
		font-style: italic;
	}

	.chat-card {
		margin-bottom: 12px;
		padding: 16px;
		background: #f8fafc;
		border-radius: 8px;
		border-left: 4px solid #e0e0e0;
		cursor: pointer;
		transition: all 0.2s;
	}

	.chat-card:hover {
		background: #eff6ff;
		border-left-color: #90caf9;
		transform: translateY(-2px);
	}

	.chat-card.active {
		background: #e3f2fd;
		border-left-color: #2196f3;
		box-shadow: 0 4px 8px rgba(33, 150, 243, 0.1);
	}

	.chat-card-header {
		display: flex;
		justify-content: space-between;
		margin-bottom: 8px;
	}

	.chat-type {
		font-weight: 600;
		font-size: 14px;
		color: #424242;
		padding: 2px 8px;
		background: #e0e0e0;
		border-radius: 4px;
	}

	.chat-type.type-1 {
		background: #e3f2fd;
		color: #1976d2;
	}

	.chat-type.type-2 {
		background: #e8f5e9;
		color: #2e7d32;
	}

	.chat-type.type-3 {
		background: #fff3e0;
		color: #e65100;
	}

	.chat-time {
		font-size: 12px;
		color: #757575;
	}

	.chat-content {
		margin-bottom: 12px;
		font-size: 14px;
		line-height: 1.5;
		color: #333;
		word-break: break-word;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		gap: 8px;
	}

	.chat-media {
		display: flex;
		gap: 12px;
		align-items: center;
	}

	/* Right Panel - Details */
	.detail-panel {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 24px;
		overflow-y: auto;
		max-height: 100%;
	}

	.qa-section, .image-section {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.detail-card {
		background: white;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		overflow: hidden;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 16px 20px;
		background: #f8fafc;
		border-bottom: 1px solid #eaedf2;
	}

	.detail-title {
		margin: 0;
		font-size: 16px;
		font-weight: 600;
		color: #2c3e50;
	}

	.card-content {
		padding: 20px;
	}

	.question-text, .question-image {
		margin-bottom: 20px;
	}

	.content-label {
		font-weight: 500;
		margin-bottom: 8px;
		color: #616161;
	}

	.content-value {
		padding: 12px;
		background-color: #f5f7fa;
		border-radius: 8px;
		line-height: 1.6;
	}

	.question-img-container {
		height: auto;
		min-height: 120px;
	}

	.question-img {
		max-width: 100%;
		border-radius: 8px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		cursor: pointer;
		transition: transform 0.2s;
	}

	.question-img:hover {
		transform: scale(1.02);
	}

	.answer-content {
		line-height: 1.6;
		padding: 16px;
		background-color: #f9f9f9;
		border-radius: 8px;
		white-space: pre-line;
	}

	.image-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 20px;
	}

	.image-item {
		flex: 1;
		min-width: 200px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.image-container {
		width: 100%;
		height: 160px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #f5f7fa;
		border-radius: 8px;
		overflow: hidden;
		margin-bottom: 8px;
	}

	.detail-img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		cursor: pointer;
		transition: transform 0.2s;
	}

	.detail-img:hover {
		transform: scale(1.05);
	}

	.no-image, .no-content {
		color: #9e9e9e;
		font-style: italic;
	}

	.image-label {
		font-size: 14px;
		color: #616161;
		margin-top: 8px;
	}

	.coordinate-container {
		flex: 1;
		min-width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.coordinate-card {
		width: 100%;
		display: flex;
		gap: 12px;
		padding: 16px;
		background: #f0f4f8;
		border-radius: 10px;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
	}

	.coordinate-icon {
		flex-shrink: 0;
		width: 32px;
		height: 32px;
		background-color: #e3f2fd;
		border-radius: 8px;
		position: relative;
	}

	.coordinate-icon:before {
		content: "";
		position: absolute;
		top: 8px;
		left: 8px;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		background-color: #2196f3;
	}

	.coordinate-content {
		flex: 1;
	}

	.position-label {
		font-weight: 500;
		color: #616161;
		margin-bottom: 8px;
	}

	.position-value {
		font-family: monospace;
		background: #e8eaf6;
		padding: 8px;
		border-radius: 4px;
		word-break: break-all;
	}

	/* Audio Button */
	.audio-btn {
		display: flex;
		align-items: center;
		gap: 6px;
		padding: 6px 12px;
		background-color: #2196f3;
		color: white;
		border: none;
		border-radius: 4px;
		cursor: pointer;
		font-size: 13px;
		transition: background-color 0.2s;
	}

	.audio-btn:hover {
		background-color: #1976d2;
	}

	.audio-icon {
		display: inline-block;
		width: 12px;
		height: 12px;
		background-color: #ffffff;
		border-radius: 50%;
		position: relative;
	}

	.audio-icon.playing::before {
		content: "";
		position: absolute;
		top: 3px;
		left: 3px;
		right: 3px;
		bottom: 3px;
		background-color: #2196f3;
		border-radius: 50%;
		animation: pulse 1s infinite;
	}

	@keyframes pulse {
		0% { transform: scale(0.8); opacity: 0.8; }
		50% { transform: scale(1.2); opacity: 1; }
		100% { transform: scale(0.8); opacity: 0.8; }
	}

	/* Thumbnail Image */
	.thumbnail-img {
		width: 60px;
		height: 60px;
		object-fit: cover;
		border-radius: 6px;
		cursor: pointer;
		border: 2px solid #e0e0e0;
		transition: all 0.2s;
	}

	.thumbnail-img:hover {
		border-color: #2196f3;
		transform: scale(1.05);
	}

	/* Modal */
	.image-modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.85);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
		cursor: pointer;
		backdrop-filter: blur(3px);
	}

	.modal-content {
		position: relative;
		max-width: 90%;
		max-height: 90%;
		animation: fadeIn 0.3s;
	}

	.close-btn {
		position: absolute;
		top: -40px;
		right: -40px;
		width: 36px;
		height: 36px;
		background: rgba(255, 255, 255, 0.2);
		color: white;
		border: none;
		border-radius: 50%;
		font-size: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		transition: background 0.2s;
	}

	.close-btn:hover {
		background: rgba(255, 255, 255, 0.4);
	}

	.large-image {
		max-width: 100%;
		max-height: 90vh;
		border-radius: 8px;
		box-shadow: 0 0 30px rgba(0, 0, 0, 0.7);
	}

	@keyframes fadeIn {
		from { opacity: 0; transform: scale(0.95); }
		to { opacity: 1; transform: scale(1); }
	}

	/* Scrollbar styling */
	.chat-list::-webkit-scrollbar, .detail-panel::-webkit-scrollbar {
		width: 8px;
		height: 8px;
	}

	.chat-list::-webkit-scrollbar-track, .detail-panel::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 4px;
	}

	.chat-list::-webkit-scrollbar-thumb, .detail-panel::-webkit-scrollbar-thumb {
		background: #bdbdbd;
		border-radius: 4px;
	}

	.chat-list::-webkit-scrollbar-thumb:hover, .detail-panel::-webkit-scrollbar-thumb:hover {
		background: #9e9e9e;
	}

	/* Simple panel styles for type 1 - simplified version */
	.simple-panel {
		max-width: 900px;
		margin: 0 auto;
	}

	.conversation-simple {
		padding: 5px 0;
	}

	.conversation-item {
		padding: 16px 0;
	}

	.item-label {
		font-weight: 600;
		color: #555;
		margin-bottom: 10px;
		font-size: 15px;
	}

	.item-content {
		line-height: 1.6;
		color: #333;
		padding: 0 5px;
		white-space: pre-line;
	}

	.item-time {
		margin-top: 8px;
		font-size: 12px;
		color: #888;
		text-align: right;
	}

	.conversation-divider {
		height: 1px;
		background-color: #eee;
		margin: 5px 0;
	}

	/* Responsive styles */
	@media screen and (max-width: 1200px) {
		.chat-history-panel {
			flex: 0 0 300px;
		}

		.image-grid {
			gap: 15px;
		}

		.image-item {
			min-width: 180px;
		}
	}

	@media screen and (max-width: 992px) {
		.mqtt-container {
			padding: 15px;
			gap: 15px;
		}

		.chat-history-panel {
			flex: 0 0 260px;
		}

		.detail-img, .question-img {
			max-height: 90%;
		}

		.image-item {
			min-width: 160px;
		}

		.card-content {
			padding: 15px;
		}
	}

	@media screen and (max-width: 768px) {
		.mqtt-container {
			flex-direction: column;
			height: auto;
			min-height: 100vh;
		}

		.chat-history-panel {
			flex: none;
			width: 100%;
			max-height: 400px;
		}

		.detail-panel {
			width: 100%;
		}

		.simple-panel {
			max-width: 100%;
		}

		.image-grid {
			flex-direction: column;
		}

		.image-item {
			width: 100%;
			margin-bottom: 15px;
		}

		.coordinate-container {
			width: 100%;
		}

		.close-btn {
			top: 0;
			right: 0;
		}
	}

	@media screen and (max-width: 576px) {
		.mqtt-container {
			padding: 10px;
			gap: 10px;
		}

		.card-header {
			flex-direction: column;
			align-items: flex-start;
			gap: 8px;
		}

		.chat-type {
			margin-bottom: 5px;
		}

		.chat-card {
			padding: 12px;
		}

		.panel-title {
			padding: 12px 15px;
			font-size: 16px;
		}

		.status-badge {
			margin: 12px 15px 0;
		}

		.detail-title {
			font-size: 15px;
		}

		.item-label, .content-label {
			font-size: 14px;
		}

		.item-content, .content-value {
			font-size: 13px;
		}
	}

	.question-list {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.question-item {
		padding: 16px;
		background: #f8f9fa;
		border-radius: 8px;
	}

	.question-number {
		font-weight: 600;
		color: #e65100;
		margin-bottom: 8px;
		font-size: 14px;
	}

	.question-content {
		color: #333;
		line-height: 1.6;
		font-size: 14px;
	}

	.question-image-container {
		margin-top: 12px;
		max-width: 200px;
	}

	.question-thumbnail {
		width: 100%;
		height: auto;
		border-radius: 6px;
		cursor: pointer;
		transition: transform 0.2s;
		box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	}

	.question-thumbnail:hover {
		transform: scale(1.05);
	}
</style>
